import { useHanaLoginMutation } from "app/apiSlice";
import LoadingSpinner from "components/LoadingSpinner";
import useModalSheet from "hooks/overlay/useModalSheet";
import { useCallback, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import TokenService from "services/tokenService";
import UserService from "../../services/userService";
import {fetchUser} from "../../app/userSlice";
import {StorageUtils} from "../../utils/storageUtils";
import {useAppDispatch} from "../../app/hooks";
import useReduxUtils from "../../hooks/useReduxUtils";

// const MAX_RETRY_COUNT = 3;
// const RETRY_DELAY = 2000; // 2초

const HanaLoginProvider = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // const [retryCount, setRetryCount] = useState(0);

  const cno = searchParams.get("cno")!;
  const ts = searchParams.get("ts");
  const link = searchParams.get("link") ?? "";
  const { resetStore } = useReduxUtils({ retainToken: false });

  const [hanaLogin, { isLoading, error }] = useHanaLoginMutation();

  const [ErrorModal, setErrorModalVisible] = useModalSheet({
    callbackOk: () => {
      window.history.back();
    },
  });

  const handleLogin = useCallback(async () => {
    if (!cno || !ts) {
      // alert("로그인 실패. 잠시 후 다시 시도해주세요.");
      setErrorModalVisible(true);
      return;
    }

    const res = await hanaLogin({ cno, ts: ts.replace(/[\s]/g, "+"), link });

    if ("data" in res) {
      const accessToken = res.data?.accessToken;
      TokenService.setAccessToken(accessToken!);
      UserService.getMyInfo().then((userInfoResponse) => {
        dispatch(fetchUser(userInfoResponse));
        StorageUtils.SavedLoginId.set(userInfoResponse.loginId);
        navigate("/" + link, {replace: true});
      });
      // }
      // else {
      //   if (retryCount < MAX_RETRY_COUNT) {
      //     setRetryCount((prev) => prev + 1);
      //     setTimeout(() => {
      //       handleLogin();
      //     }, RETRY_DELAY);
    } else {
      //     // 최대 재시도 횟수 초과 시 에러 처리
      //     // alert("로그인 실패. 잠시 후 다시 시도해주세요.");
      setErrorModalVisible(true);
    }
    // }
  }, [cno, hanaLogin, dispatch, link, navigate, setErrorModalVisible, ts]);

  useEffect(() => {
    TokenService.removeAccessToken();
    resetStore();

    handleLogin();
  }, [cno, ts, link, handleLogin]);

  return (
    <>
      <LoadingSpinner overlap />
      <ErrorModal modal>
        <div>
          <p className="font-bold">로그인 실패</p>
          <p className="font-bold">잠시 후 다시 시도해주세요.</p>
        </div>
      </ErrorModal>
    </>
  );
};

export default HanaLoginProvider;
